import React, { memo } from 'react';
import cc from 'classcat';
import SingleDateTab from './SingleDateTab';
import HorizontalSlider from '../HorizontalSlider';
import './datetabs.style.scss';
/**
 * // TODO: document this
 * @param props
 * @constructor
 */
var DateTabs = function (props) {
    var value = props.value, onChange = props.onChange, timestamps = props.timestamps, className = props.className, monthlyView = props.monthlyView;
    return (React.createElement("div", { className: cc(['date-tab', className]) },
        React.createElement(HorizontalSlider, { value: value, onChange: onChange, center: true, slides: timestamps.map(function (timestamp) { return ({
                id: timestamp,
                content: React.createElement(SingleDateTab, { timestamp: timestamp, key: timestamp, monthlyView: monthlyView }),
            }); }) })));
};
DateTabs.defaultProps = {
    monthlyView: false,
};
export default memo(DateTabs);
